import React from "react";
import { connect } from "react-redux";

import LoginController from "./LoginController.jsx";

import { checkForCurrentSession, setBrowserType, checkTermsAndConditionsAccepted } from "actions/login.js";

// mapStateToProps is a react-redux specific function
// that injects the redux store, after filters. REQUIRED
//    state = reduxStore
//    ownProps = props passed to container Component (Not Meteor data)
const mapStateToProps = (state, ownProps) => {
	// console.log("-->", state);
	// console.log(ownProps)
	return {
		checkedForExistingUserOnLoad: state.login.checkedForExistingUserOnLoad,
		currentProject: state.login.currentProject,
		darkUI: state.projectConfig ? state.projectConfig.darkUI : "unset",
		loggedIn: state.login.loggedIn,
		termsAndConditionsAccepted: state.login.termsAndConditionsAccepted,
		userName: state.login.userName,
		userPool: state.login.userPool,
	};
};

// mapDispatchToProps is a react-redux specific
// function that binds a function into the props
// Default is: dispatch => ({ dispatch }), to this isn't necessary in simple uses
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		checkForCurrentSession: (projectCookie) => {
			dispatch(checkForCurrentSession(projectCookie));
		},
		setBrowserType: (browser) => {
			dispatch(setBrowserType(browser));
		},
		checkTermsAndConditionsAccepted: () => {
			dispatch(checkTermsAndConditionsAccepted());
		},
	};
};

// const mergeProps = ( stateProps, actionProps, parentProps ) => ({
// ...stateProps,
// ...actionProps,
// ...parentProps
// });

// Combines everything
const LoginControllerContainer = connect(
	mapStateToProps,
	mapDispatchToProps
	// mergeProps
)(LoginController);

export default LoginControllerContainer;
